const routes = [
  // 增值内容管理
  {
    path: "/incrementContents",
    name: "incrementContents",
    meta: {
      title: '增值内容管理',
      hasBack: false
    },
    component: () => import("../pages/incrementContents/index.vue")
  },
  // 授权学员管理
  {
    path: "/incrementContents/student",
    name: "incrementContents/student",
    meta: {
      title: '授权学员管理',
      hasBack: false
    },
    component: () => import("../pages/incrementContents/authStudent/authStudent.vue")
  },
  // 加入记录
  {
    path: "/joinRecord",
    name: "joinRecord",
    meta: {
      title: '加入记录',
      hasBack: false
    },
    component: () => import("../pages/incrementContents/joinRecord/index.vue")
  },
];

export default routes;
